import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/reducers/app.state';
import { ClassificationSearchState } from '../reducers/classification-search.state';

// Selector functions
const getAppState = createFeatureSelector<AppState>('appstate');

export const getLoaders = createSelector(
  getAppState,
  state => state.loaders
);

export const getInternetRegistration = createSelector(
  getAppState,
  ( state: AppState ) => state.internetRegistration
);

export const selectClassificationSearchState = createFeatureSelector<ClassificationSearchState>('classificationsearchstate');

export const getClassifications = createSelector(
  selectClassificationSearchState,
  state => state.classifications
);